<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
  },
  methods: {},
}
</script>

<style lang="scss">
.loadingBox {
  position: fixed;
  z-index: 999999;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000071;
  color: #fff;
  font-size: 14px;
}

.ladingSapn {
  position: relative;
	width: 200px;
	height: 200px;
	left: 50%;
	top: 50%;
  -webkit-transform: translate(-50%,-50%);
  -ms-transform: translate(-50%,-50%);
	transform: translate(-50%,-50%);
}

body {
  width: 100%;
  height: 100vh;
  overflow: auto;
}

* {
  margin: 0;
  padding: 0;
}

ul,
li {
  list-style: none;
}</style>
